module.exports = __webpack_public_path__ + "static/media/icon-supplies-razor.66593d39.svg";